/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/no-extraneous-dependencies
import { produce } from 'immer';

export default (set, get, visualizerMetaDataAndChoiceId, resetDropZones) => {
  const { metadata: { Sku: sku = null }, choiceId } = visualizerMetaDataAndChoiceId;
  const selectVisualizerItem = get().selectVisualizerItem;

  resetDropZones();
  selectVisualizerItem(null);

  return set(produce(get(), (draft) => {
    if (!draft.design) {
      draft.design = {};
    }
    draft.design.selectedProduct = {
      itemId: sku,
      choiceId
    };
  }), false, {
    type: 'SELECT',
    payload: {
      itemId: sku,
      choiceId
    }
  });
};
